import React, { useRef } from "react";
import cx from "classnames";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "./InputErrorList";
import "./Input.scss";
import "./OtpInput.scss";
export function OtpInput({ value, label, onChange, onBlur, disabled = false, validators = [], forceValidation = false, readOnly = false, screenReaderInputLabels, }) {
    const inputName = useRef("otp_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const inputs = useRef([
        null,
        null,
        null,
        null,
        null,
        null,
    ]);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(value, validators, forceValidation);
    useForm(inputName.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const classes = cx("lysa-ui-input", validityClasses, {
        "lysa-ui-input-read-only": readOnly,
    });
    const numbers = value
        .split("")
        .concat(["-", "-", "-", "-", "-", "-"])
        .slice(0, 6);
    const singleInput = (num, index) => (React.createElement("span", { className: "otp-input-label-input-wrapper" },
        screenReaderInputLabels[index] && (React.createElement("label", { className: "sr-only", htmlFor: inputName.current + "_" + index }, screenReaderInputLabels[index])),
        React.createElement("input", { className: "otp-input-single", value: num === "-" ? "" : num, id: inputName.current + "_" + index, disabled: disabled, type: "text", inputMode: "numeric", pattern: "[0-9]", ref: (el) => {
                inputs.current[index] = el;
            }, autoComplete: index === 0 ? "one-time-code" : undefined, onChange: (e) => {
                const value = e.target.value;
                const number = (value.charCodeAt(0) || 0) - "0".charCodeAt(0);
                if (value.length > 1 ||
                    (value !== "" && (number < 0 || number > 9))) {
                    setTimeout(() => {
                        var _a, _b;
                        (_a = inputs.current[index]) === null || _a === void 0 ? void 0 : _a.focus();
                        (_b = inputs.current[index]) === null || _b === void 0 ? void 0 : _b.select();
                    });
                    return;
                }
                const newNumbers = [...numbers];
                newNumbers[index] = value === "" ? "-" : "" + number;
                onChange === null || onChange === void 0 ? void 0 : onChange(newNumbers.join(""));
                if (value.length) {
                    setTimeout(() => {
                        var _a;
                        (_a = inputs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                }
            }, onBlur: () => onBlur && onBlur(), onFocus: (event) => {
                event.target.select();
            }, onKeyDown: (e) => {
                if (e.key === "Backspace" && num === "-") {
                    const newNumbers = [...numbers];
                    newNumbers[index - 1] = "-";
                    onChange === null || onChange === void 0 ? void 0 : onChange(newNumbers.join(""));
                    setTimeout(() => {
                        var _a;
                        (_a = inputs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    });
                }
                if (num !== "-" && e.key === num) {
                    setTimeout(() => {
                        var _a;
                        (_a = inputs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    });
                }
                if (e.key === "ArrowLeft") {
                    setTimeout(() => {
                        var _a;
                        (_a = inputs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    });
                }
                if (e.key === "ArrowRight") {
                    setTimeout(() => {
                        var _a;
                        (_a = inputs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    });
                }
            }, onPaste: (e) => {
                var _a;
                const data = (e.clipboardData || window.clipboardData).getData("Text");
                if (data.length === 1) {
                    return;
                }
                if (data.length === 6 && !isNaN(+data)) {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange === null || onChange === void 0 ? void 0 : onChange(data);
                }
                if (data.length > 6) {
                    e.preventDefault();
                    e.stopPropagation();
                    const code = (_a = data.split(/[\w\d]{1,3}-/)) === null || _a === void 0 ? void 0 : _a[1];
                    if (typeof code !== "undefined" && code.length === 6) {
                        onChange === null || onChange === void 0 ? void 0 : onChange(code);
                    }
                }
            } })));
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group otp-input" },
        React.createElement("label", { htmlFor: inputName.current + "_" + 0 }, label),
        React.createElement("div", { className: classes },
            React.createElement("div", { className: "otp-input-group" },
                singleInput(numbers[0], 0),
                singleInput(numbers[1], 1),
                singleInput(numbers[2], 2)),
            React.createElement("div", { className: "otp-input-group" },
                singleInput(numbers[3], 3),
                singleInput(numbers[4], 4),
                singleInput(numbers[5], 5))),
        React.createElement(InputErrorList, { errorMessages: errorMessages })));
}
